import { FC } from 'react';
import { TradeAssuranceTerms } from './TradeAssuranceTerms';

export const TradeAssuranceTermsPage: FC = () => {
  return <TradeAssuranceTerms />;
};
